import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContainerReportFilter = _resolveComponent("ContainerReportFilter")!
  const _component_Report = _resolveComponent("Report")!

  return (_openBlock(), _createBlock(_component_Report, {
    ref: "reportComponent",
    reportType: "ContainerReport"
  }, {
    reportSettings: _withCtx(({ loading }) => [
      _createVNode(_component_ContainerReportFilter, {
        onOnReport: _ctx.onReport,
        onOnStop: _ctx.onStop,
        loading: loading
      }, null, 8, ["onOnReport", "onOnStop", "loading"])
    ]),
    _: 1
  }, 512))
}